// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getWishListLinesDataView } from "@insite/client-framework/Store/Data/WishListLines/WishListLinesSelectors";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import deleteWishListLine from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/DeleteWishListLine";
import loadWishListLines from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";
import setQuantityAdjustmentModalIsOpen from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SetQuantityAdjustmentModalIsOpen";
import updateLoadWishListLinesParameter from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateLoadWishListLinesParameter";
import updateWishListLine from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateWishListLine";
import translate from "@insite/client-framework/Translate";
import { WishListLineModel } from "@insite/client-framework/Types/ApiModels";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TwoButtonModal from "@insite/content-library/Components/TwoButtonModal";
import Modal from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

import StoreCheckoutCartLinesHeaderInformations, {
    StoreCheckoutCartLinesHeaderProps,
} from "@store/Library/Components/Foundation/StoreCheckout/StoreCheckoutCartLinesHeaderInformations";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import loadWishListIfNeeded from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListIfNeeded";
import setAllWishListLinesIsSelected from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SetAllWishListLinesIsSelected";
import setEditingSortOrder from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SetEditingSortOrder";
import PlusCircle from "@insite/mobius/Icons/PlusCircle";
import { Icon, Pagination } from "@insite/mobius/index";
import getColor from "@insite/mobius/utilities/getColor";
import SelectInline, { SelectInlineStyles } from "@store/Library/Components/Toolkit/SelectInline";
import Checkbox, { CheckboxProps } from "@store/MobiusOverrides/Checkbox/Checkbox";
import LoadingOverlay from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import useBuyingList from "@store/Framework/Common/Hooks/useBuyingList/useBuyingList";
import { CustomWidgetModule } from "@store/Framework/Types/types";
import ManageProductsModal from "@store/Library/Components/BuyingList/ManageProductsModal";
import {
    BuyingListProductListSortable,
    useBuyingListProductListSortable,
} from "@store/Library/Widgets/BuyingList/BuyingListProductListSortable";
import {
    MyListsDetailsProductListStyles,
    productListStyles,
} from "@store/Overrides/Widgets/MyListsDetails/MyListsDetailsProductList";
import styled, { css } from "styled-components";
import { FormFieldIcon } from "@store/MobiusOverrides/FormField/FormField";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";

const mapStateToProps = (state: ApplicationState) => ({
    wishListDataView: getWishListState(state, state.pages.myListDetails.wishListId),
    wishListLinesDataView: getWishListLinesDataView(state, state.pages.myListDetails.loadWishListLinesParameter),
    wishListLinesParameter: state.pages.myListDetails.loadWishListLinesParameter,
    productInfosByWishListLineId: state.pages.myListDetails.productInfosByWishListLineId,
    selectedWishListLineIds: state.pages.myListDetails.selectedWishListLineIds,
    loadWishListLinesParameter: state.pages.myListDetails.loadWishListLinesParameter,
    editingSortOrder: state.pages.myListDetails.editingSortOrder,
    quantityAdjustmentModalIsOpen: state.pages.myListDetails.quantityAdjustmentModalIsOpen,
});

const enum fields {
    showImageBadges = "showImageBadges",
    maximumNumberOfImageBadges = "maximumNumberOfImageBadges",
    showTextBadges = "showTextBadges",
    maximumNumberOfTextBadges = "maximumNumberOfTextBadges",
    showSpecificationModal = "showSpecificationModal",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.showImageBadges]: boolean;
        [fields.maximumNumberOfImageBadges]: number;
        [fields.showTextBadges]: boolean;
        [fields.maximumNumberOfTextBadges]: number;
        [fields.showSpecificationModal]: boolean;
    };
}

const mapDispatchToProps = {
    updateLoadWishListLinesParameter,
    loadWishListLines,
    setEditingSortOrder,
    updateWishListLine,
    setQuantityAdjustmentModalIsOpen,
    deleteWishListLine,
    loadWishListIfNeeded,
    setAllWishListLinesIsSelected,
};
const AddProductLink = styled.div<{ isAdmin: boolean }>`
    color: ${getColor("primary")};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    row-gap: 0.25rem;
    ${({ isAdmin }) =>
        isAdmin &&
        css`
            :hover {
                transition: all 0.3s ease-in-out;
                transform: scale(1.03);
                color: ${getColor("secondary")} !important;
            }
        `}
`;

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;
interface BuyingListDetailsProductListStyles extends MyListsDetailsProductListStyles {
    selectInline?: SelectInlineStyles;
}
const buyingListDetailsProductListStyles: BuyingListDetailsProductListStyles = {
    ...productListStyles,
    linesCountWrapper: {
        css: css`
            ${productListStyles.linesCountWrapper?.css}
            row-gap: ${pxToRem(8)};
        `,
    },
    selectInline: {
        wrapper: {
            css: css`
                width: auto;
                ${breakpoint("sm", "down")} {
                    display: inline-flex;
                }
            `,
        },

        select: {
            mergeCss: true,
            labelProps: {
                css: css`
                    display: flex;
                    min-height: auto;
                    margin: 0;
                    line-height: 1.5;
                    width: auto;
                `,
            },
            cssOverrides: {
                formField: css`
                    margin-bottom: 0;
                    gap: ${pxToRem(8)};
                    ${FormFieldIcon} {
                        right: -3px;
                        overflow: visible;
                    }
                `,
                formInputWrapper: css`
                    width: auto;
                `,
            },
        },
    },
};

const styles = buyingListDetailsProductListStyles;

const BuyingListDetailsProductList: React.FC<Props> = ({
    productInfosByWishListLineId,
    quantityAdjustmentModalIsOpen,
    setQuantityAdjustmentModalIsOpen,
    deleteWishListLine,
    wishListDataView,
    wishListLinesDataView,
    loadWishListLinesParameter,
    updateLoadWishListLinesParameter,
    setEditingSortOrder,
    loadWishListLines,
    wishListLinesParameter,
    editingSortOrder,
    selectedWishListLineIds,
    setAllWishListLinesIsSelected,
    fields,
}) => {
    const { updateBuyingLists, loading, activeWishList, updateBuyingListLine, getBuyingLists } = useBuyingList();
    const [wishListLineToAction] = React.useState<WishListLineModel | null>(null);
    const [deleteLineModalIsOpen, setDeleteLineModalIsOpen] = React.useState(false);
    const [productModalIsOpen, setProductModalIsOpen] = React.useState(false);
    const { onSortMove, updateSortOrder } = useBuyingListProductListSortable(activeWishList, updateBuyingListLine);
    const {
        showImageBadges,
        showTextBadges,
        maximumNumberOfImageBadges,
        maximumNumberOfTextBadges,
        showSpecificationModal,
    } = fields;

    // this is needed to fix a visual bug caused by react-hoc-sortable.  Currently without this fix the dragging element is not visible.
    // the sortable container takes a helperClass (in this case sortable-helper) and adds it to the dragging element.  Numerous attempts to add the class styling with styled components failed
    // so this is a workaround to add the class to the head of the document on mount and remove it on unmount.
    useEffect(() => {
        const head = document.head;
        const style = document.createElement("style");

        style.innerHTML = ".sortable-helper { z-index: 9999; outline: 2px solid #0D2C6B; outline-offset: .25rem;}";

        head.appendChild(style);
        return () => {
            head.removeChild(style);
        };
    }, []);
    const isAdmin = useAppSelector(state => getCurrentAccountState(state)?.value?.role === "Administrator");
    const wishList = activeWishList;

    const handleChangePage = (page: number) => {
        if (
            !page ||
            page < 1 ||
            page > ((wishListLinesDataView?.value && wishListLinesDataView.pagination?.numberOfPages) || 1)
        ) {
            return;
        }
        updateLoadWishListLinesParameter({
            page,
        });
    };
    const handleChangeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = Number(event.target.value);
        updateLoadWishListLinesParameter({
            page: 1,
            pageSize: newPageSize,
        });
    };
    const deleteCancelHandler = () => {
        setDeleteLineModalIsOpen(false);
    };

    const deleteSubmitHandler = () => {
        if (!wishListLineToAction) {
            return;
        }

        deleteWishListLine({
            wishListId: wishList?.id || "",
            wishListLineId: wishListLineToAction.id,
            onSuccess: () => {
                setDeleteLineModalIsOpen(false);
            },
            onComplete() {
                // "this" is targeting the object being created, not the parent SFC
                // eslint-disable-next-line react/no-this-in-sfc
                this.onSuccess?.();
            },
        });
    };

    const deleteClickHandler = (wishListLine: WishListLineModel) => {
        if (activeWishList) {
            updateBuyingLists(activeWishList, { itemsToRemove: [wishListLine?.id] });
        }
    };
    const sortByChangeHandler = (sortBy: string) => {
        setEditingSortOrder({ editingSortOrder: false });
        updateLoadWishListLinesParameter({ sort: sortBy });
        loadWishListLines();
    };
    const quantityAdjustmentModalCancelHandler = () => {
        setQuantityAdjustmentModalIsOpen({ modalIsOpen: false });
    };
    const headerProps: StoreCheckoutCartLinesHeaderProps = {
        controlLabels: [
            { label: translate("Quantity") },
            { label: translate("Extended Price") },
            { label: translate("Availability") },
            { label: translate("Actions") },
        ],
        extendedStyles: styles.storeCheckoutHeaderStyles,
    };
    const isLoading =
        wishListDataView?.isLoading ||
        wishListLinesDataView?.isLoading ||
        !activeWishList ||
        !wishListLinesDataView ||
        loading;
    let hasMoreThanOnePage = false;

    if ("pagination" in wishListLinesDataView) {
        hasMoreThanOnePage = (wishListLinesDataView.pagination?.numberOfPages || 1) > 1;
    }

    useEffect(() => {
        if (
            wishListDataView.value?.pagination?.page !== wishListLinesParameter.page &&
            !wishListLinesDataView.isLoading
        ) {
            if (activeWishList) {
                loadWishListLines();
            }
        }
    }, [loadWishListLines, wishListDataView.value, wishListLinesDataView.isLoading, wishListLinesParameter.page]);

    const wishListLines = wishListLinesDataView.value || [];

    const selectAllChangeHandler: CheckboxProps["onChange"] = (_, value) => {
        const allWishListLineIds = value ? wishListLines?.map(o => o.id) : undefined;
        setAllWishListLinesIsSelected({ isSelected: value, wishListLineIds: allWishListLineIds });
    };
    let linesCount = 0;
    if ("pagination" in wishListLinesDataView) {
        linesCount = wishListLinesDataView.pagination?.totalItemCount || 0;
    }

    const isAllSelected =
        wishListLines &&
        wishListLines.length > 0 &&
        wishListLines?.every(o => selectedWishListLineIds.indexOf(o.id) >= 0);

    return (
        <LoadingOverlay
            style={{ height: "100%", minHeight: "30vh" }}
            loading={isLoading}
            data-test-selector="buyingListProductList_loadingOverlay"
        >
            {activeWishList && (
                <ManageProductsModal
                    buyingList={activeWishList}
                    isOpen={productModalIsOpen}
                    onClose={() => setProductModalIsOpen(false)}
                    data-test-selector="buyingListProductList_manageProductsModal"
                />
            )}
            {isLoading ? null : (
                <>
                    {!isLoading && (wishListLines.length || 0) === 0 ? (
                        <StyledWrapper
                            {...styles.centeringWrapper}
                            data-test-selector="buyingListProductList_emptyStateWrapper"
                        >
                            <Typography
                                {...styles.messageText}
                                data-test-selector="buyingListProductList_noItemsMessage"
                            >
                                {loadWishListLinesParameter.query ? (
                                    siteMessage("Lists_NoResultsMessage")
                                ) : (
                                    <AddProductLink
                                        isAdmin={isAdmin}
                                        onClick={isAdmin ? () => setProductModalIsOpen(true) : undefined}
                                        data-test-selector="buyingListProductList_addProductLink"
                                    >
                                        {isAdmin && (
                                            <Icon
                                                css={css`
                                                    color: inherit;
                                                `}
                                                size={30}
                                                src={PlusCircle}
                                                data-test-selector="buyingListProductList_addProductIcon"
                                            />
                                        )}
                                        {isAdmin
                                            ? siteMessage("Lists_NoItemsInList")
                                            : translate("This List Has No Items")}
                                    </AddProductLink>
                                )}
                            </Typography>
                        </StyledWrapper>
                    ) : (
                        <>
                            <StyledWrapper
                                {...styles.linesCountWrapper}
                                data-test-selector="buyingListProductList_headerWrapper"
                            >
                                <Checkbox
                                    {...styles.selectAll}
                                    checked={isAllSelected}
                                    onChange={selectAllChangeHandler}
                                    data-test-selector="buyingListProductList_selectAllCheckbox"
                                >
                                    {translate("Select All")}
                                </Checkbox>
                                {isAdmin && (
                                    <Checkbox
                                        {...styles.selectAll}
                                        checked={editingSortOrder}
                                        onChange={() => setEditingSortOrder({ editingSortOrder: !editingSortOrder })}
                                        data-test-selector="buyingListProductList_editSortOrderCheckbox"
                                    >
                                        {translate("Edit Sort Order")}
                                    </Checkbox>
                                )}
                                <Typography {...styles.linesCount} data-test-selector="buyingListProductList_itemCount">
                                    {linesCount} {linesCount === 1 ? translate("Item") : translate("Items")}
                                </Typography>
                                <SelectInline
                                    label={`${translate("Sort by")}${translate(":")}`}
                                    labelPosition="left"
                                    extendedStyles={styles.selectInline}
                                    uid="myLists_sort"
                                    value={loadWishListLinesParameter.sort}
                                    onChange={event => sortByChangeHandler(event.currentTarget.value)}
                                    data-test-selector="buyingListProductList_sortSelect"
                                >
                                    {wishListLinesDataView.value &&
                                        wishListLinesDataView.pagination?.sortOptions?.map(sortOption => (
                                            <option value={sortOption.sortType} key={sortOption.sortType}>
                                                {sortOption.displayName}
                                            </option>
                                        ))}
                                </SelectInline>
                            </StyledWrapper>
                            <StoreCheckoutCartLinesHeaderInformations
                                {...headerProps}
                                data-test-selector="buyingListProductList_headerInformations"
                            />
                            <BuyingListProductListSortable
                                gridItemProps={styles.lineGridItem}
                                showSpecificationModal={showSpecificationModal}
                                helperClass="sortable-helper"
                                wishList={{ ...wishList!, allowEdit: isAdmin, isSharedList: true }}
                                wishListLines={wishListLines}
                                productInfosByWishListLineId={productInfosByWishListLineId}
                                isEditingSortOrder={editingSortOrder}
                                canDrag={!hasMoreThanOnePage}
                                updateSortOrder={updateSortOrder}
                                onDeleteClick={deleteClickHandler}
                                useDragHandle={true}
                                lockAxis="y"
                                quantityUpdateOnSuccess={() => getBuyingLists(true)}
                                lockToContainerEdges={true}
                                lockOffset="0%"
                                customWishListLineUpdate={updateBuyingListLine}
                                onSortStart={(_, e) => e.preventDefault()}
                                onSortMove={onSortMove}
                                onSortEnd={({ oldIndex, newIndex }) =>
                                    updateSortOrder(wishListLines[oldIndex], newIndex + 1)
                                }
                                onEditNotesClick={() => {}}
                                data-test-selector="buyingListProductList_sortableList"
                                showImageBadges={showImageBadges}
                                maximumNumberOfImageBadges={maximumNumberOfImageBadges}
                                showTextBadges={showTextBadges}
                                maximumNumberOfTextBadges={maximumNumberOfTextBadges}
                            />

                            {hasMoreThanOnePage && "pagination" in wishListLinesDataView && (
                                <Pagination
                                    resultsCount={wishListLinesDataView?.pagination?.totalItemCount || 0}
                                    currentPage={wishListLinesDataView?.pagination?.page || 1}
                                    resultsPerPage={wishListLinesDataView?.pagination?.pageSize || 0}
                                    resultsPerPageOptions={wishListLinesDataView.pagination?.pageSizeOptions || []}
                                    onChangePage={handleChangePage}
                                    onChangeResultsPerPage={handleChangeResultsPerPage}
                                    data-test-selector="buyingListProductList_pagination"
                                />
                            )}
                            <TwoButtonModal
                                modalIsOpen={deleteLineModalIsOpen}
                                headlineText={translate("Delete List Item")}
                                messageText={`${translate("Are you sure you want to delete this item?")}`}
                                cancelButtonText={translate("Cancel")}
                                submitButtonText={translate("Delete")}
                                onCancel={deleteCancelHandler}
                                onSubmit={deleteSubmitHandler}
                                submitTestSelector="buyingListProductList_deleteModal_submit"
                                data-test-selector="buyingListProductList_deleteModal"
                            />

                            <Modal
                                {...styles.quantityAdjustmentModal}
                                headline={translate("Quantity Adjustment Has Been Made")}
                                isOpen={quantityAdjustmentModalIsOpen}
                                handleClose={quantityAdjustmentModalCancelHandler}
                                data-test-selector="buyingListProductList_quantityAdjustmentModal"
                            >
                                <Typography
                                    {...styles.quantityAdjustedText}
                                    data-test-selector="buyingListProductList_quantityAdjustedText"
                                >
                                    {siteMessage("Lists_QuantitiesAdjusted")}
                                </Typography>
                            </Modal>
                        </>
                    )}
                </>
            )}
        </LoadingOverlay>
    );
};

const widgetModule: CustomWidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(BuyingListDetailsProductList),

    definition: {
        group: "Buying List",
        displayName: "Product List",
        fieldDefinitions: [
            {
                name: fields.showImageBadges,
                displayName: "Image Badges",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.maximumNumberOfImageBadges,
                editorTemplate: "DropDownField",
                isVisible: widget => widget.fields.showImageBadges,
                defaultValue: "4",
                options: [
                    { displayName: "1", value: "1" },
                    { displayName: "2", value: "2" },
                    { displayName: "3", value: "3" },
                    { displayName: "4", value: "4" },
                    { displayName: "5", value: "5" },
                    { displayName: "6", value: "6" },
                    { displayName: "7", value: "7" },
                    { displayName: "8", value: "8" },
                ],
                fieldType: "General",
                sortOrder: 2,
            },
            {
                name: fields.showTextBadges,
                displayName: "Text Badges",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 3,
            },
            {
                name: fields.maximumNumberOfTextBadges,
                editorTemplate: "DropDownField",
                isVisible: widget => widget.fields.showTextBadges,
                defaultValue: "4",
                options: [
                    { displayName: "1", value: "1" },
                    { displayName: "2", value: "2" },
                    { displayName: "3", value: "3" },
                    { displayName: "4", value: "4" },
                    { displayName: "5", value: "5" },
                    { displayName: "6", value: "6" },
                    { displayName: "7", value: "7" },
                    { displayName: "8", value: "8" },
                ],
                fieldType: "General",
                sortOrder: 4,
            },
            {
                name: fields.showSpecificationModal,
                displayName: "Show Specification Modal",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                sortOrder: 5,
            },
        ],
    },
};

export default widgetModule;
